var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"notification",class:[_vm.notificationClass.type, {active: _vm.notificationClass.active, hidden: !_vm.notificationClass.active}]},[_vm._v(_vm._s(_vm.notification.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }